import { render, staticRenderFns } from "./maternitytreatment.vue?vue&type=template&id=109738cd&"
import script from "./maternitytreatment.vue?vue&type=script&lang=js&"
export * from "./maternitytreatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports